<template>
  <div class="vaultFeesRowContainer">
    <div class="container">
      <div class="row">

        <div class="col-12">
          <h4 class="font-size-32 text-center mt-1 mb-3 mt-sm-5 mb-sm-6">
            {{ vaultFees.title }}
          </h4>
        </div>

        <div
          v-for="(section, index) in vaultFees.sections"
          :key="index"
          class="col-sm-6"
          :class="section.classes ? section.classes : ''"
        >
          <div class="feeSection">
            <div class="feeImage">
              <div class="feeImageBox">
                <img :alt="section.title" class="img-fluid" :src="section.image" />
              </div>
            </div>
            <div class="feeBody">
              <h4 class="font-size-24 text-center">
                {{ section.title }}
              </h4>

              <div class="text-success font-weight-bold my-4 text-center" v-html="section.price" />

              <p
                v-for="(paragraph, index) in section.paragraphs"
                :key="index"
                class="text-center"
                :class="paragraph.classes"
              >
                {{ paragraph.content }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-12 text-center">
          <a class="btn btn-primary mb-5 font-weight-black" :href="submit.url">
            {{ submit.text }}
          </a>

          <p v-for="text in vaultFees.bodyText" :key="text" class="mb-0" v-html="text"/>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import { vaultFees } from '../constants/vaultConstants';

export default {
  name: 'VaultFeesRow',
  data() {
    return {
      submit: jsConfig.links.submit,
      vaultFees
    };
  }
};
</script>

<style lang="scss">
  @import '@sass/vue-imports.scss';

  .vaultFeesRowContainer {
    .container {
      padding: 35px 15px 70px 15px;
    }

    .feeSection {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .feeImage {
      position: relative;

      &:after {
        position: absolute;
        content: '';
        height: 40%;
        width: 100%;
        border: 1px solid $light-gray;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom: none;
        z-index: 1;
        bottom: 0;
      }
    }

    .feeImageBox {
      position: relative;
      background: #fff;
      max-width: 57%;
      margin: 0 auto;
      padding: 0 30px 20px 30px;
      z-index: 2;

      @include media-breakpoint-down(sm) {
        max-width: 85%;
      }
    }

    .last .feeImageBox {
      max-width: 95%;
      margin-bottom: 5%;
      @include media-breakpoint-down(md) {
        max-width: 90%;
        padding: 0 20px 20px;
        margin-bottom: 4%;
      }
      @include media-breakpoint-down(sm) {
        margin-top: 15%;
        margin-bottom: 13%;
      }
    }

    .feeBody {
      border: 1px solid $light-gray;
      border-radius: 10px;
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
      margin-bottom: 60px;
      padding: 0 15px 30px 15px;
      border-top: none;
      flex: 1 0;
    }
  }
</style>
